<h6 id="table_operaSecondariaList">Elenco opere secondarie</h6>
<div style="transform: rotateX(180deg);" class="table-responsive mb-3">
    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_operaSecondariaList">
        <thead class="thead-light">
            <tr>
                <th scope="col">ID</th>
                <th scope="col">Categoria/Macrotipologia opera</th>
                <th scope="col">Tipologia opera</th>
                <th scope="col">Materiale costruzione</th>
                <th scope="col">Materiale rivestimento</th>
                <!-- <th scope="col">Sponda</th> -->
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items">
                <td>{{ item.idOperaSecondaria }}</td>
                <td>{{ item.macroTipologiaOpera | anagraficaMacroTipologiaOpera: (datalist.macroTipologiaOpera || []) }}</td>
                <td>{{ item.idTipologiaOpera | anagraficaTipologiaOpera: (datalist.tipologiaOpera || []) }}</td>
                <td>{{ item.idMaterialeCostruzione | anagraficaMateriale: (datalist.materiale || []) }}</td>
                <td>{{ item.idMaterialeRivestimento | anagraficaMateriale: (datalist.materiale || []) }}</td>
                <!-- <td>{{ item.idSponda | anagraficaSponda: (datalist.sponda || []) }}</td> -->
                <td class="actions">
                    <button aria-label="visualizza dettagli" type="button" (click)="viewItem(item)" class="btn btn-xs btn-link" container="body" ngbTooltip="Visualizza dettaglio">
                        <app-toolkit-bl-icon icon="search" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="modifica" *ngIf="canEdit" type="button" (click)="editItem(item)" class="btn btn-xs btn-link" container="body" ngbTooltip="Modifica">
                        <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="elimina" *ngIf="canEdit" class="btn btn-xs btn-link" (click)="deleteItem(item.idOperaSecondaria)" container="body" ngbTooltip="Elimina">
                        <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                    </button>                  
                </td>
            </tr>
            <tr *ngIf="!items.length">
                <td colspan="6"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="canEdit" class="button-actions">
    <button type="button" class="btn btn-outline-primary" (click)="addItem()">
        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Aggiungi
    </button>
</div>